import { Divider, Typography } from '@mui/material';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface IProps {
  day?: string;
  pictureDayStatus?: string;
}

function EventDayStatusSummary({ day, pictureDayStatus }: IProps) {
  return (
    <>
      <AccordionSummary
        data-testid='event-day-summary'
        sx={{ p: 0 }}
        expandIcon={<ExpandMoreIcon sx={{ color: '#0275d8' }} />}
      >
        <Typography sx={{ float: 'left' }}>{day + ':'}</Typography>
        <Typography sx={{ float: 'left', ml: 1, fontWeight: 1000 }}>
          {pictureDayStatus}
        </Typography>
      </AccordionSummary>
      <Divider variant='fullWidth' />
    </>
  );
}

export default EventDayStatusSummary;
